export default __webpack_public_path__ + "static/pubertad-3c0efbdcfd2fab4e7ae9bb702a67dc23.png";